import { createStore } from "vuex";
import { vuexOidcCreateStoreModule } from "vuex-oidc";
import { oidcSettings } from "../config/auth";

export default createStore({
  modules: {
    oidcStore: vuexOidcCreateStoreModule(oidcSettings, {publicRoutePaths: ['/'], isAuthenticatedBy: 'access_token'})
  }
})
